import { PoolInfo } from "../types";

export const blastInfo: Record<string, PoolInfo> = {
  // weth-usdb
  "0x1f06e6e226bE4F0a66B7f8b1007997DC9De1eBC7": {
    chainId: 81457,
    flip: true,
    unwrap: "base",
  },
  // musd-usdb
  "0xb312D61915c878938fcE09D13DD3006c6835b3e5": {
    chainId: 81457,
    flip: true,
  },
  // weth-usdb
  "0xA24D9FB1CA3909DaaAF62503c766680d087E72B9": {
    chainId: 81457,
    flip: true,
    unwrap: "base",
  },
  // blast-weth
  "0x1E4dC872E7a2731fE91ECC654e4FEE4B65178c9d": {
    chainId: 81457,
    flip: true,
    unwrap: "quote",
  },
  // blast-usdb
  "0xEA3513719153Be844809C0Dc64c7E2aE4972Ba8A": {
    chainId: 81457,
    flip: true,
  },
  // usde-usdb
  "0xc91D6032d72796b9a0558Ab9ef45C100c9fDe1f8": {
    sparksPerQuotePerDay: 0.033,
    chainId: 81457,
    flip: true,
  },
  // susde-usdb
  "0x12afF531E86f5E9763c6C7D0994AdEfB1a1f844c": {
    sparksPerQuotePerDay: 0.033,
    isFarm: true,
    chainId: 81457,
    flip: true,
  },
};
